module.exports = __webpack_public_path__ + "img/teacup.6594dd95.png";